(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eye-dragon-landing"]) return;
  try {
    
  document.querySelectorAll('[data-landing-section]').forEach((section) => {
    const slides = Array.from(section.querySelectorAll('[data-media-slide]'));
    const thumbs = Array.from(section.querySelectorAll('[data-media-thumb]'));
    const select = section.querySelector('[data-variant-select]');
    const options = Array.from(section.querySelectorAll('[data-variant-option]'));
    const stickyInput = section.querySelector('[data-sticky-variant]');
    const stickyButton = section.querySelector('[data-sticky-button]');
    const mainButton = section.querySelector('[data-add-button]');
    const sticky = section.querySelector('[data-landing-sticky]');
    const mediaStage = section.querySelector('.landing-media__stage');
    const previousButton = section.querySelector('[data-media-previous]');
    const nextButton = section.querySelector('[data-media-next]');
    let mediaIndex = 0;
    let scrollFrame;
    let pointerStartX;
    let cartSubmissionInProgress = false;
    const productForms = Array.from(section.querySelectorAll('.landing-form, .landing-sticky__form'));
    const cartStatus = section.querySelector('[data-cart-submit-state]');

    const setCartBusy = (busy) => {
      cartSubmissionInProgress = busy;
      [mainButton, stickyButton].forEach((button) => {
        button.disabled = busy || select.selectedOptions[0]?.disabled === true;
        if (busy) button.setAttribute('aria-busy', 'true');
        else button.removeAttribute('aria-busy');
      });
    };

    const currentCartCount = () => {
      const value = document.querySelector('[data-testid="cart-bubble"]')?.textContent?.trim();
      return Number.parseInt(value || '0', 10) || 0;
    };

    const updateCartCount = (count) => {
      const bubble = document.querySelector('[ref="cartBubble"]');
      const countElement = document.querySelector('[data-testid="cart-bubble"]');
      bubble?.classList.remove('visually-hidden');
      countElement?.classList.remove('hidden');
      if (countElement) countElement.textContent = count > 99 ? '99+' : String(count);
    };

    const replaceCartSections = (sections) => {
      Object.entries(sections || {}).forEach(([sectionId, html]) => {
        if (typeof html !== 'string') return;
        const currentSection = document.getElementById(`shopify-section-${sectionId}`);
        if (!currentSection) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = parsed.getElementById(`shopify-section-${sectionId}`) || parsed.body.firstElementChild;
        if (nextSection) currentSection.replaceWith(nextSection);
      });
    };

    const submitCart = async (event) => {
      event.preventDefault();
      if (cartSubmissionInProgress) return;
      mainButton.setCustomValidity('');

      const form = event.currentTarget;
      const formData = new FormData(form);
      const quantity = Number(formData.get('quantity')) || 1;
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((component) => component.dataset.sectionId)
        .filter(Boolean);

      if (sectionIds.length) formData.set('sections', sectionIds.join(','));
      formData.set('sections_url', window.location.pathname);
      setCartBusy(true);

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || mainButton.dataset.errorMessage);
        }

        replaceCartSections(result.sections);
        updateCartCount(currentCartCount() + quantity);

        if (cartStatus) {
          cartStatus.hidden = false;
          window.setTimeout(() => { cartStatus.hidden = true; }, 1500);
        }
        window.requestAnimationFrame(() => document.getElementById('cart-drawer')?.open?.());
      } catch {
        HTMLFormElement.prototype.submit.call(form);
      } finally {
        setCartBusy(false);
      }
    };

    const showMedia = (index) => {
      if (!slides.length) return;
      mediaIndex = Math.max(0, Math.min(index, slides.length - 1));
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === mediaIndex));
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === mediaIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
        if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
      const count = section.querySelector('[data-media-count]');
      if (count) count.textContent = `${mediaIndex + 1} / ${slides.length}`;
      if (previousButton) previousButton.disabled = mediaIndex === 0;
      if (nextButton) nextButton.disabled = mediaIndex === slides.length - 1;
    };

    const setVariant = (option) => {
      if (!option) return;
      const variant = {
        id: option.dataset.variantOption,
        title: option.dataset.variantTitle,
        price: option.dataset.price,
        priceCents: Number(option.dataset.priceCents),
        comparePrice: option.dataset.comparePrice,
        compareCents: Number(option.dataset.compareCents),
        available: option.dataset.available === 'true',
        featuredMedia: option.dataset.featuredMedia,
      };

      select.value = variant.id;
      stickyInput.value = variant.id;
      options.forEach((item) => {
        const active = item === option;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', active);
      });

      section.querySelector('[data-current-price]').textContent = variant.price;
      const compare = section.querySelector('[data-compare-price]');
      const discount = section.querySelector('[data-discount]');
      const discounted = variant.compareCents > variant.priceCents;
      compare.hidden = !discounted;
      discount.hidden = !discounted;
      if (discounted) {
        compare.textContent = variant.comparePrice;
        discount.textContent = `${Math.round((variant.compareCents - variant.priceCents) * 100 / variant.compareCents)}%`;
      }

      section.querySelector('[data-sticky-price]').textContent = variant.price;
      mainButton.disabled = !variant.available;
      stickyButton.disabled = !variant.available;
      const addLabel = section.querySelector('[data-add-label]');
      const addPrice = section.querySelector('[data-add-price]');
      addPrice.hidden = !variant.available;
      if (variant.available) addPrice.textContent = `- ${variant.price}`;

      if (variant.featuredMedia) {
        const featuredIndex = slides.findIndex((slide) => slide.dataset.mediaId === variant.featuredMedia);
        if (featuredIndex >= 0) showMedia(featuredIndex);
      }

      addLabel.textContent = variant.available ? stickyButton.dataset.availableLabel : stickyButton.dataset.soldOutLabel;
      stickyButton.textContent = variant.available ? stickyButton.dataset.availableLabel : stickyButton.dataset.soldOutLabel;
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(Number(thumb.dataset.mediaThumb))));
    previousButton?.addEventListener('click', () => showMedia(mediaIndex - 1));
    nextButton?.addEventListener('click', () => showMedia(mediaIndex + 1));
    mediaStage?.addEventListener('pointerdown', (event) => {
      pointerStartX = event.clientX;
    });
    mediaStage?.addEventListener('pointerup', (event) => {
      if (pointerStartX === undefined) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = undefined;
      if (Math.abs(distance) < 45) return;
      showMedia(mediaIndex + (distance < 0 ? 1 : -1));
    });
    mediaStage?.addEventListener('pointercancel', () => {
      pointerStartX = undefined;
    });
    options.forEach((option) => option.addEventListener('click', () => setVariant(option)));
    select.addEventListener('change', () => setVariant(options.find((option) => option.dataset.variantOption === select.value)));
    productForms.forEach((form) => form.addEventListener('submit', submitCart));

    const updateSticky = () => {
      sticky.classList.toggle('is-visible', mainButton.getBoundingClientRect().bottom < 0);
      scrollFrame = undefined;
    };

    window.addEventListener('scroll', () => {
      if (!scrollFrame) scrollFrame = requestAnimationFrame(updateSticky);
    }, { passive: true });

    updateSticky();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jintu-home"] && !Shopify.designMode) return;
  try {
    
  const initializeJintuTabs = (root = document) => {
    root.querySelectorAll('.jintu-home').forEach((section) => {
      if (section.dataset.tabsReady === 'true') return;
      section.dataset.tabsReady = 'true';

      const tabs = [...section.querySelectorAll('[role="tab"]')];

      const activate = (tab, moveFocus = false) => {
        tabs.forEach((candidate) => {
          const selected = candidate === tab;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-selected', String(selected));
          candidate.tabIndex = selected ? 0 : -1;
          const panel = section.querySelector(`#${candidate.getAttribute('aria-controls')}`);
          if (panel) panel.hidden = !selected;
        });
        if (moveFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          activate(tabs[nextIndex], true);
        });
      });

    });
  };

  initializeJintuTabs();
  document.addEventListener('shopify:section:load', (event) => initializeJintuTabs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
